// Единая карта статусов приглашений и формат дат для всех страниц
// (AllInvitations, TestInvitations). Не дублировать локально на страницах.

const BADGE_BASE = 'inline-flex px-2 py-1 text-xs font-semibold rounded-full';

const STATUS_MAP = {
  pending: { label: 'Ожидает прохождения', colors: 'bg-gray-100 text-gray-700' },
  completed: { label: 'Ждёт проверки', colors: 'bg-yellow-100 text-yellow-800' },
  passed: { label: 'Прошёл', colors: 'bg-green-100 text-green-800' },
  failed: { label: 'Не прошёл', colors: 'bg-red-100 text-red-800' },
  deferred: { label: 'Отложен', colors: 'bg-blue-100 text-blue-800' },
  timeout: { label: 'Время истекло', colors: 'bg-orange-100 text-orange-800' },
};

// Возвращает { label, className } для бейджа статуса приглашения.
// Неизвестный/пустой статус трактуется как pending.
export function getInvitationStatus(status) {
  const entry = STATUS_MAP[status] || STATUS_MAP.pending;
  return { label: entry.label, className: `${BADGE_BASE} ${entry.colors}` };
}

// Единый формат дат: «ДД.ММ.ГГГГ, ЧЧ:ММ» (ru-RU).
export function formatInvitationDate(iso) {
  if (!iso) return '-';
  return new Date(iso).toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
